import { render, staticRenderFns } from "./Editseat.vue?vue&type=template&id=3452e149&scoped=true&"
import script from "./Editseat.vue?vue&type=script&lang=js&"
export * from "./Editseat.vue?vue&type=script&lang=js&"
import style0 from "./Editseat.vue?vue&type=style&index=0&id=3452e149&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3452e149",
  null
  
)

export default component.exports